import { useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { Box, DialogContent, Tab, TabContent, TabNav, Tabs } from '@pocketlaw/tetris';
import { FormDialog } from 'shared/domains/forms';
import { Contacts } from './Contacts';
import { Content } from './Content';
import { Footer } from './Footer';
import { Header } from './Header';
import { useGetSchema } from './useGetSchema';
import { getInitialValues } from './utils';
export function DefaultRecipientModal(props) {
    const { allRecipients, initialValues, onClose, onSubmit } = props;
    const [tabId, setTabId] = useState('form');
    const isEdit = initialValues !== undefined;
    const initialFormValues = getInitialValues(initialValues);
    const formSchema = useGetSchema({ allRecipients, isEdit, initialEmail: initialValues === null || initialValues === void 0 ? void 0 : initialValues.email });
    const handleSelectTab = (newTabId) => {
        setTabId(newTabId);
    };
    return (<FormDialog size="lg" initialValues={initialFormValues} validationSchema={formSchema} onSubmit={onSubmit} onClose={onClose}>
      <Header isEdit={isEdit} onClose={onClose}/>

      <Tabs activeTab={tabId} onSelect={handleSelectTab}>
        <Box mx="2xl" flexDirection="column">
          <TabNav>
            <Tab id="form">
              <Trans comment="Label for eSigning recipients tab">Information</Trans>
            </Tab>
            <Tab id="contact-library">
              <Trans comment="Label for eSigning recipients tab">Contact library</Trans>
            </Tab>
          </TabNav>
        </Box>

        <DialogContent>
          <Box display="block" pt="2xl">
            <TabContent tabId="contact-library">
              <Contacts onSelect={() => handleSelectTab('form')}/>
            </TabContent>

            <TabContent tabId="form">
              <Content />
            </TabContent>
          </Box>
        </DialogContent>
      </Tabs>

      <Footer isEdit={isEdit} onClose={onClose} setTabId={setTabId} disabled={tabId === 'contact-library'}/>
    </FormDialog>);
}
